// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"28ee670c","453":"a081ef43","455":"bf9fbff5"}[chunkId] + ".chunk.js";
};